export const presetThemes = [
  {
    key: 'aurora-slate',
    copy: 'Aurora',
    thumbnailUrlKey: 'cactus_slate',
  },
  {
    key: 'splendor-black',
    copy: 'Splendor',
    thumbnailUrlKey: 'splendor_black',
  },
  {
    key: 'tahoe-tan',
    copy: 'Tahoe',
    thumbnailUrlKey: 'tahoe_burnt-orange',
  },
  {
    key: 'afton-pink',
    copy: 'Afton',
    thumbnailUrlKey: 'afton_pink',
  },
];

export const blankInitialValues = {
  public: true,
  collect_rsvps: false,
  country_code: 'US',
  type: '',
};



// WEBPACK FOOTER //
// ./src/pages/Events/util/constants.js